import type { NfseDocumento } from '@/services/ServicosNfse';
import { useObterNfse } from '@/services/ServicosNfse';
import { getChaveAcessoDoc } from '../../utils';

/**
 * O detalhe da linha clicada: vai com o contribuinte da linha, porque a mesma chave pode estar gravada para o
 * prestador e para o tomador do mesmo gestor (SPEC-011).
 */
export function useDetalhesNfseModal(documento: NfseDocumento | null, open: boolean) {
  const chaveAcessoDoc = getChaveAcessoDoc(documento);
  const query = useObterNfse(chaveAcessoDoc, documento?.CNPJ_Contribuinte, {
    enabled: open && !!chaveAcessoDoc,
  });

  return {
    chaveAcessoDoc,
    ...query,
  };
}
